export const SET = 'ta/user/SET'
export const REMOVE = 'ta/user/REMOVE'
